import { importAll } from '@/utils/importHelpers';

// Import all showcase images
const showcaseImages = importAll(
  import.meta.glob('/src/assets/showcase/*.{png,jpg,jpeg,PNG}', { eager: true })
) as string[];

// Sort images to ensure consistent order
const sortedImages = [...showcaseImages].sort();

// Split images into groups for different animations
const totalImages = sortedImages.length;
const imagesPerGroup = Math.ceil(totalImages / 4);

// Create groups with different intervals for variety
export const showcaseData = [
  {
    images: sortedImages.slice(0, imagesPerGroup),
    interval: 6000,
    transitionDuration: 1000,
    effect: 'fade-scale' as const
  },
  {
    images: sortedImages.slice(imagesPerGroup, imagesPerGroup * 2),
    interval: 7000,
    transitionDuration: 1000,
    effect: 'fade-scale' as const
  },
  {
    images: sortedImages.slice(imagesPerGroup * 2, imagesPerGroup * 3),
    interval: 8000,
    transitionDuration: 1000,
    effect: 'fade-scale' as const
  },
  {
    images: sortedImages.slice(imagesPerGroup * 3),
    interval: 9000,
    transitionDuration: 1000,
    effect: 'fade-scale' as const
  }
] as const;